import Spritesheet from 'react-responsive-spritesheet';
import './loadingIndicator.sass';

export default function LoadingIndicator() {
  return <Spritesheet className="loading-indicator" image="https://prod.cdni.callofduty.com/prelogin/media/sprite_loader.png" widthFrame={64} heightFrame={64} steps={15} fps={30} loop autoplay startAt={1} endAt={15} direction="forward" isResponsive />;
}
